import React from "react";

import { SectionContainer } from "../../components/SectionContainer";
import { Headline } from "../../components/Headline";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { Media } from "../../components/Media/Media";

import { generateClassString } from "../../lib/helper/generateClassString";

import * as styles from "./mediaFullWidth.module.less";
import { Tagline } from "../../components/Tagline/Tagline";
import { useIsTablet } from "../../lib/hooks/mediaQueries";

export function MediaFullWidth({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        subheadline,
        mediaElements,
        background
    },
    type
}) {
    const isTablet = useIsTablet();

    return (
        <SectionContainer
            sectionId={anker}
            sectionClass={styles.mediaSectionContainer}
            containerClass={styles.container}
            background={background}
        >
            <div className="reducedWidth">
                <Tagline>{tagline}</Tagline>

                <Headline semanticOfHeadline={semanticOfHeadline}>
                    {headline}
                </Headline>

                <StructuredTextRenderer
                    data={subheadline}
                    contentElementType={type}
                />
            </div>

            {mediaElements.map((mediaElement) => {
                const {
                    id,
                    media,
                    mediaDescription,
                    hideImageDescription,
                    hideGrid
                } = mediaElement;

                const description = mediaDescription || media?.alt

                return (
                    <div key={id} className={styles.mediaContainer}>
                        <Media
                            mediaElement={mediaElement}
                            className={generateClassString([
                                media.isImage,
                                styles.image,
                                styles.video
                            ])}
                            videoControls={true}
                            gridDisable={hideGrid}
                            gridSize={isTablet ? "s" : "m"}
                        />
                        {!hideImageDescription && description && (
                            <p className={styles.imageDescription}>
                                {description}
                            </p>
                        )}
                    </div>
                );
            })}
        </SectionContainer>
    );
}
